import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3cf338f2&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=3cf338f2&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf338f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cf338f2')) {
      api.createRecord('3cf338f2', component.options)
    } else {
      api.reload('3cf338f2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3cf338f2&scoped=true&", function () {
      api.rerender('3cf338f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rule/mcheck/index.vue"
export default component.exports